import { request } from './http';
import { Member, Organization, OrganizationSummary, OrgRole } from './types';

export const listOrganizations = () =>
  request<{ organizations: OrganizationSummary[] }>('/organizations', 'GET');

export const createOrganization = (body: { name: string; timezone?: string }) =>
  request<Organization & { defaultProjectId: string }, typeof body>(
    '/organizations',
    'POST',
    body,
  );

/** The organization resolved for this request - see `setCurrentOrganizationId`. */
export const getOrganization = () =>
  request<Organization>('/organization', 'GET');

export const updateOrganization = (body: {
  name?: string;
  timezone?: string;
}) => request<Organization, typeof body>('/organization', 'PATCH', body);

export const deleteOrganization = () =>
  request<{ message: string }>('/organization', 'DELETE');

export const setDefaultOrganization = () =>
  request<{ message: string; organizationId: string }>(
    '/organization/default',
    'PUT',
  );

export const listMembers = () =>
  request<{ members: Member[] }>('/organization/members', 'GET');

export const inviteMember = (body: { email: string; role: OrgRole }) =>
  request<
    Pick<Member, 'userId' | 'email' | 'role' | 'status' | 'invitedAt'>,
    typeof body
  >('/organization/members/invite', 'POST', body);

export const updateMemberRole = (userId: string, body: { role: OrgRole }) =>
  request<{ userId: string; role: OrgRole }, typeof body>(
    `/organization/members/${encodeURIComponent(userId)}`,
    'PATCH',
    body,
  );

/** Removing yourself is how you leave an organization. */
export const removeMember = (userId: string) =>
  request<{ message: string }>(
    `/organization/members/${encodeURIComponent(userId)}`,
    'DELETE',
  );
